'use es6';

import I18n from 'I18n';
import ContentText from '../atoms/ContentText';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getPlainText } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import EmailCaptureInput from './EmailCaptureInput';
import { CANDY_APPLE } from 'HubStyleTokens/colors';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorMessage = styled.span.withConfig({
  displayName: "CaptureSection__ErrorMessage",
  componentId: "sc-18ghevz-0"
})(["color:", ";font-size:12px;line-height:18px;text-align:left;margin-top:9px;display:flex;"], CANDY_APPLE);
export const CaptureSection = ({
  message,
  email,
  errorMessage,
  onChange,
  onKeyPress,
  onSubmit,
  submissionState
}) => {
  return /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
    children: [/*#__PURE__*/_jsx(ContentText, {
      messageId: message.id,
      "aria-label": `${I18n.text('conversations-visitor-message-history.agentSays')} ${getPlainText(message)}`,
      contentText: getPlainText(message)
    }), /*#__PURE__*/_jsx(EmailCaptureInput, {
      disabled: !email,
      value: email,
      onChange: onChange,
      onKeyPress: onKeyPress,
      onSubmit: onSubmit,
      submissionState: submissionState
    }), /*#__PURE__*/_jsx(ErrorMessage, {
      "aria-live": "assertive",
      children: errorMessage
    })]
  }, "email-prompt-capture-section");
};
CaptureSection.displayName = 'CaptureSection';
CaptureSection.propTypes = {
  email: PropTypes.string,
  errorMessage: PropTypes.string,
  message: RecordPropType('EmailCapturePromptMessage').isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submissionState: PropTypes.string.isRequired
};